import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { BiSelectMultiple } from 'react-icons/bi';
import QdtComponent from '../../components/QdtComponent';
import { qdtComponents } from '../../config/globalApp';
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';

export default function Selections() {

	const {goToTop} = useApp()

	useEffect(() => {
    goToTop()

		document.querySelector<HTMLInputElement>(`input[class=lui-search__input]`)?.blur()
  }, [goToTop])

	async function ClearScoresSelections() {
		const qApp = await qdtComponents.qAppPromise;
		await qApp?.clearAll();
	}

  return (
		<motion.div variants={fadeIn} initial="hidden" animate="show">
			<section className="section-space bg-selections-img bg-overlay bg-img-property bg-overlay">
        <div className="container">
          <div className="row rowsafari">
            <div className="col-lg-12">
              <div className="row">
                <BiSelectMultiple color={'white'} size={54}/>
                <h3 className="text-white text-center pt-2">Selections</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
			<section className="mt-3 mb-3">
				<div className="container">
					<div className="row mb-3">
						<div className="col "><h6 className="section-grp-margin-bottom text-success fs-3">Selections</h6></div>
						<div className="col text-light text-end">
							<button onClick={() => ClearScoresSelections()} className="btn btn-warning text-success">Clear Selections</button>
						</div>
					</div>
					<div className="row rowsafari">
						<div className="col-lg-4 col-md-6 col-sm-12 col-4 res-desk-mar-bot border-sm-bottom ">
							<div className="border border-success rounded bg-light">
								<QdtComponent
									type="QdtViz"
									props={{
										id: 'VzXJmx',
										height: '550px'
									}}
								/>	
							</div>
						</div>
						<div className="col-lg-4 col-md-6 col-sm-12 col-4 res-desk-mar-bot">
							<div className="border border-success rounded bg-light">
								<QdtComponent
									type="QdtViz"
									props={{
										id: 'pfpjsvm',
										height: '550px'
									}}
								/>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 col-sm-12 col-4 res-mob-mar-bot">
							<div className="border border-success rounded bg-light">
								<QdtComponent
									type="QdtViz"
									props={{
										id: 'zfPJzv',
										height: '550px'
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</motion.div>
  )
}